import React, {useEffect, useState} from "react";
import {Row, Col} from "react-bootstrap";
import {FormField} from "../../forms";
import NawSelector from "./NawSelector";
import portalApi from "../../../api/portal";
import notyfApi from "../../../utils/notyfApi";


// Handle the algemeen tab in the overview page.
const GeneralSettings = () => {
    const[users, setUsers] = useState({
        sellers: [], // verkopers
        leaders: [], // project leiders
    })
    useEffect(()=>{
        getUsers()
    }, [])

    // Get all users from the portal, so they can be selected in the form.
    const getUsers = async () =>{
        const resSellers=  await portalApi.getUsersByRole("Verkopers")
        const resLeaders= await  portalApi.getUsersByRole("Projectleider")

        if(!resSellers.ok || !resLeaders.ok) return notyfApi.error("probleem met gebruikers ophalen")
        setUsers({

        sellers: resSellers.data.users,
        leaders: resLeaders.data.users,
        })

    }
    return <>
        <h4>Project Gegevens</h4>
        <Row>
            <Col>
                <FormField name={"service_form_project_name"}
                           label={"Projectnaam"}
                           className={"mb-3"}
                           control={"input"}
                           disabled={true}
                />
                <FormField name={"service_form_project_reference"}
                           label={"Projectnummer"}
                           className={"mb-3"}
                           control={"input"}
                           disabled={true}

                />
                <FormField name={"service_form_project_building_address"}
                           label={"Project gebouw adres"}
                           className={"mb-3"}
                           control={"input"}

                />
                <FormField name={"service_form_project_building_zipcode"}
                           label={"Project gebouw Postcode/Plaats"}
                           className={"mb-3"}
                           control={"input"}
                />
                <FormField name={"project_btw"}
                           label={"BTW"}
                           className={"mb-3"}
                           control={"input"}
                           as={"select"}
                >
                    <option value="">BTW(21%)</option>
                    <option value="">BTWverlegd(0%)/WKA</option>
                </FormField>
                <FormField name={"project_term"}
                           label={"Betalingstermijn"}
                           className={"mb-3"}
                           control={"input"}
                           as={"select"}
                >
                    <option value="">STANDAARD (KING)</option>
                    <option value="">7 dagen</option>
                    <option value="">14 dagen</option>
                    <option value="">30 dagen</option>
                    <option value="">45 dagen</option>
                    <option value="">60 dagen</option>
                </FormField>
                <FormField name={"service_form_project_seller"}
                           label={"Verkoper"}
                           className={"mb-3"}
                           control={"input"}
                           as={"select"}
                >
                    {users.sellers.map(s => <option value={s.name}>{s.name}</option>)}
                </FormField>
                <FormField name={"project_manager"}
                           label={"Projectleider"}
                           className={"mb-3"}
                           control={"input"}
                           as={"select"}
                >
                    {users.leaders.map(s => <option value={s.name}>{s.name}</option>)}
                </FormField>
            </Col>
        </Row>
        <hr/>
        <h4>NAW</h4>
        <NawSelector/>
        <FormField name={"service_form_project_account_name"}
                   label={"Bedrijf"}
                   className={"mb-3"}
                   control={"input"}
        />
        <Row>
            <Col lg={10}>
                <FormField name={"service_form_project_street"}
                           label={"Straat"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
            <Col>
                <FormField name={"service_form_project_street_nr"}
                           label={"Nummer"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
        </Row>
        <Row>
            <Col lg={4}>
                <FormField name={"service_form_project_postal_code"}
                           label={"Postcode"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
            <Col>
                <FormField name={"service_form_project_city"}
                           label={"Stad"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
        </Row>
        <Row>
            <Col lg={4}>
                <FormField name={"service_form_project_firstname"}
                           label={"Voornaam"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
            <Col>
                <FormField name={"service_form_project_surname_prefix"}
                           label={"Tussenvoegsel"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
            <Col>
                <FormField name={"service_form_project_lastname"}
                           label={"Achternaam"}
                           className={"mb-3"}
                           control={"input"}
                />
            </Col>
        </Row>
        <FormField name={"service_form_project_email"}
                   label={"Email"}
                   className={"mb-3"}
                   control={"input"}
        />
        <FormField name={"service_form_project_account_phone_nr"}
                   label={"Telefoonnummer"}
                   className={"mb-3"}
                   control={"input"}
        />
    </>
}
export default GeneralSettings